import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function SDM18HCL(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_SDM18HCLS':
            return core.setSDM18HCLs(state, action.SDM18HCLs);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM18HCLS':
            return core.updateSDM18HCLs(state, action.SDM18HCLs);
        case 'MYFHE__FHEPRODUCT_SET_SDM18HCL_DETAILS':
            return core.setSDM18HCLDetails(state, action.SDM18HCLId, action.SDM18HCLDetails);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM18HCL_STATUS':
            return core.updateSDM18HCLStatus(state, action.productIdentifier, action.status);
        case 'MYFHE__FHEPRODUCT_MASTER_SWITCH_SDM18HCL':
            return core.switchSDM18HCLMaster(state, action.productIdentifier, action.masterId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_SDM18HCL':
            return core.dissociateUserFromSDM18HCL(state, action.productIdentifier, action.userId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SDM18HCL':
            return core.dissociateUserFromSDM18HCLAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }
    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18HCL/reducer.js